<div id="orderData-invoice" class="container" style="background: white; min-height: 95vh; width: 80vw;">
  <!-- top row -->
  <div class="row justify-content-between m-4 pt-4">
    <!-- akorion address -->
    <div class="col-4 address">
      <p class="akorion font-weight-bold">Akorion company LTD</p>
      <p>P.O Box 6638, Kampala</p>
      <p>Plot 33 Lumumba Avenue</p>
      <p>Interservice tower 3rd Floor</p>
    </div>
    <!-- invoice details and date-->
    <div class="col-3">
      <div class="font-weight-bold blue">Purchase Order</div>
      <div class="font-weight-bold">Number: <span class="font-weight-normal">#{{purchaseOrder.lpo}}</span></div>
      <div class="font-weight-bold">Date: <span class="font-weight-normal">{{date | date:'MM-dd-yyyy'}}</span></div>
    </div>
  </div>
  <!-- empty space -->
  <div class="row mbt-4"></div>

  <!-- row 2 -->
  <div class="row justify-content-between m-4 pt-4">
    <!-- to name -->
    <div class="col-4">
      <div class="font-weight-bold">Order to:</div>
      <div class="text-uppercase font-weight-bold">{{purchaseOrder.supplier_name}}</div>
    </div>
    <!-- location adrress -->
    <div class="col-4">
      <div class="font-weight-bold text-uppercase">Ship to:</div>
      <p class="akorion font-weight-bold">Akorion company LTD</p>
      <p>P.O Box 6638, Kampala</p>
      <p>Plot 33 Lumumba Avenue</p>
      <p>Interservice tower 3rd Floor</p>
    </div>

  </div>

  <!-- row 3 -->
  <div class="row m-4 pt-4">
    <!-- items table -->
    <table class="table table-striped table-borderDataed">
      <thead>
        <tr>
          <th scope="col">Item</th>
          <th scope="col">Package</th>
          <th scope="col-2">Description</th>
          <th scope="col">Quantity</th>
          <th scope="col">Unit Price</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of items; let rowIndex=index">
          <td>{{ order.product_name }}</td>
          <td>{{ order.package }}</td>
          <td></td>
          <td>{{ order.qty }}</td>
          <td>{{order.unitPrice}}</td>
          <td>{{order.qty * order.unitPrice}}</td>
        </tr>
      </tbody>
      <tfoot class="borderDataless">
        <tr>
          <td colspan="5" class="text-right">Total</td>
          <td>{{totalCost | currency: 'UGX'}}</td>
        </tr>
      </tfoot>
    </table>

  </div>

</div>